import { translations } from "../../translations"
import styles from "./AboutMeWindow.module.css"

export default function InterestsSection() {
    return (
        <section className={styles.section}>
            <div className={styles.sectionTitleRow}>
                <img src="/images/icons/introduction.svg" className={styles.sectionIconImg} alt="" />
                <h2 className={styles.sectionTitle}>{translations('about_me.introduction')}</h2>
            </div>
            <ul className={styles.sectionText}>
                <span>{translations('about_me.introduction_paragraph')}</span>
            </ul>
        </section>
    )
}
